import React, { Fragment } from "react";
export var SkeletonCheckbox = function (props) { return (React.createElement(Fragment, null,
    React.createElement("label", { htmlFor: "loadingCheckbox", className: props === null || props === void 0 ? void 0 : props.className },
        React.createElement("input", { name: "loading", id: "loadingCheckbox", disabled: true, type: "checkbox" }),
        React.createElement("span", { className: "sr-only" }, "Select all rows")))); };
